import React from 'react'
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {errorToast, successToast} from "../../components/layout/ToastStyles";
import {Apis} from "../../util/data";
import {PageBackLabel} from "../../components/layout/PageBackLabel";
import PageSection from "../../components/layout/PageSection";
import PageTitle from "../../components/layout/PageTitle";
import PageContainer from "../../components/layout/PageContainer";
import RiskForm from "./RiskForm";


const RiskNew = () => {
  const navigate = useNavigate()

  const onCreate = async (risk) => {
    await axios.post(Apis.PROD + '/riesgo/new',risk)
      .then(res => {
        successToast("Riesgo creado correctamente")
        navigate('/riesgos')
      })
      .catch(err => {
        errorToast(err.response.data.message,6000)
      });
  }

  return (
    <PageContainer>
      <PageSection>
        <PageBackLabel text='Riesgos' onClick={() => navigate('/riesgos')}/>
        <PageTitle title={'Riesgo nuevo'}/>
      </PageSection>

      <PageSection>
        <RiskForm value={{}} onSubmit={(risk) => onCreate(risk)}/>
      </PageSection>
    </PageContainer>
  )
}

export default RiskNew;
